import React from 'react';
import './LoginIllustration.css';

const LoginIllustration = () => {
  return (
    <div className="login-illustration-container">
      <img 
        src="/assets/images/gohire_login_hero.png" 
        alt="GoHire Login Illustration" 
        className="login-hero-image"
      />
    </div>
  );
};

export default LoginIllustration;
